import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './styles/base.scss';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './authentication/authConfig';
import { ThemeProvider } from '@mui/system';
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
 palette: {
  primary: {
    light: '#fff',
    main: '#01033b',
    dark: '#01033b',
    contrastText: '#fff',
  }
}});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <MsalProvider instance={msalInstance}>
          <App />          
        </MsalProvider>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
